import { useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useBooksUIContext } from "../BooksUIContext";
import { BookCategoryOptions, CustomSelect, FilterOptions, getBookTypeOptions, GradeOptions } from "../../../../../../_helpers/Helpers";

const prepareFilter = (queryParams, values) => {
  const { name, author, category, type, grade, createdBy } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name, author, category, type, grade, createdBy };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function BooksFilter() {
  // Books UI Context
  const booksUIContext = useBooksUIContext();
  const booksUIProps = useMemo(() => {
    return {
      queryParams: booksUIContext.queryParams,
      setQueryParams: booksUIContext.setQueryParams
    };
  }, [booksUIContext]);  
    
  const [bookTypeOptions, setBookTypeOptions] = useState(FilterOptions);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(booksUIProps.queryParams, values);
    if (!isEqual(newQueryParams, booksUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      booksUIProps.setQueryParams(newQueryParams);
    }
  };

  const categoryOptions = FilterOptions.concat(BookCategoryOptions);
  const gradeOptions = FilterOptions.concat(GradeOptions);
  
  return (
    <Formik
      initialValues={{
        name: "",
        author: "",
        createdBy: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="author"
                placeholder="Yazarı"
                onBlur={handleBlur}
                value={values.author}
                onChange={(e) => {
                  setFieldValue("author", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Yazarı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={categoryOptions}
                value={values.category}
                placeholder="Kategorisi"
                onBlur={handleBlur}
                onChange={e => {
                  if (e.value === undefined) setBookTypeOptions(FilterOptions);
                  else setBookTypeOptions(FilterOptions.concat(getBookTypeOptions(e.value)));              
                  setFieldValue("category", e.value);
                  setFieldValue("type", undefined);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kategorisi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={bookTypeOptions}
                value={values.type}
                placeholder="Türü"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("type", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Türü</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="createdBy"
                placeholder="Ekleyen"
                onBlur={handleBlur}
                value={values.createdBy}
                onChange={(e) => {
                  setFieldValue("createdBy", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ekleyen</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}